import { defineMessage } from '@lingui/macro';

import InputText from './InputText';

export const ACCESS_CONTROL_FIELDNAME = 'access_control_code';

const ACCESS_CONTROL_PROVIDER_AXESS = 'axess';

const InputAccessControlCode = ({ accessControlPartner, ...props }) => {
  const handleOnChange = (fName, fieldValue, additionalData) => {
    if (accessControlPartner != ACCESS_CONTROL_PROVIDER_AXESS) {
      props.onChange(fName, fieldValue, additionalData);
      return;
    }

    const formattedAccessCode = formatAxessCode(fieldValue);
    props.onChange(fName, formattedAccessCode, additionalData);
  };

  return (
    <>
      {accessControlPartner == ACCESS_CONTROL_PROVIDER_AXESS && (
        <InputText
          fieldLabel={defineMessage({ message: 'Code on your Hero Pass' })}
          fieldPlaceholder="XXXXXXXX-XXX-XXX"
          {...props}
          onChange={handleOnChange}
          minWidth="240px"
        />
      )}
    </>
  );
};

export default InputAccessControlCode;

// We auto format the axess code because users forget to put the dashes
// We are permissive to let them write the dashes themselves if they want
// Axess code has always 3 parts : XXXXXXXX-YYY-ZZZ
const formatAxessCode = raw => {
  const withLettersAndDashes = raw.replace(/[^A-Za-z0-9-]/g, '').toUpperCase();

  const withoutDashes = withLettersAndDashes.replace(/-/g, '');
  const part1 = withoutDashes.slice(0, 8);
  const part2 = withoutDashes.slice(8, 11);
  const part3 = withoutDashes.slice(11, 14);

  let formatted = part1;
  if (part2.length) formatted += '-' + part2;
  if (part3.length) formatted += '-' + part3;

  // preserve their manually written dash
  if (raw.endsWith('-') && !formatted.endsWith('-') && formatted.length < 14 + 2) {
    formatted += '-';
  }
  return formatted;
};
